import { render, staticRenderFns } from "./BillRequestsList.vue?vue&type=template&id=72189144&scoped=true&"
import script from "./BillRequestsList.vue?vue&type=script&lang=js&"
export * from "./BillRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./BillRequestsList.vue?vue&type=style&index=0&id=72189144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72189144",
  null
  
)

export default component.exports